// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"a3db6e44","285":"7d76c842","296":"c008e8e0","377":"caf581d9","479":"e07bc5eb","599":"a576503f","936":"02a8c672","948":"e98d032b","985":"08f09ed1"}[chunkId] + ".chunk.js";
};